<template>
  <div id="app">
    <div class="stagingBar" v-show="isStaging===true">*** Staging ***</div>
    <div class="container-fluid">
      <transition name="fade">
        <router-view :key="$route.fullPath"></router-view>
      </transition>
    </div>
    <div class="loadingGif"><img src="@/assets/images/load.gif" width="100" height="100" alt="Loading" /></div>
    <div class="popDialog errorBox" aria-role="alert" v-show="errorDialog!==null">

      <div v-text="errorDialog"></div>
      <div class="text-right mt-2 text-center">
        <button class="btn-std btn-short" @click="closeDialog">Close</button>
      </div>
    </div>
    <div class="popDialog successBox" aria-role="alert" v-show="successDialog!==null">

      <div v-text="successDialog"></div>
      <div class="text-right mt-2 text-center">
        <button class="btn-std btn-short" @click="closeDialog">Close</button>
      </div>
    </div>

    <div class="popDialog warningBox" aria-role="alert" v-show="warnDialog!==null">

      <div v-text="warnDialog"></div>
      <div class="text-right mt-2 text-center">
        <button class="btn-std btn-short" @click="closeDialog">Close</button>
      </div>
    </div>

  </div>

</template>

<style scoped>
  .loadingGif {
    top:50%;
    left:50%;
    margin-left:-32px;
    margin-top:-32px;
    position:fixed;
    z-index:10;
  }
  .popDialog {
    position:fixed;
    top:2%;
    right:2%;
  }
  .stagingBar {
    background: red;
    color: white;
    position: fixed;
    top: 0;
    left: 0;
    width: 20px;
    font-size: 0.9em;
    height: 100%;
    text-align: center;
    z-index: 10000;
    writing-mode: vertical-lr;
    text-orientation: upright;
  }
</style>

<script>
export default {
  name: 'AppLayout',
  data() {
    return {
      errorDialog: null,
      isStaging: false,
      successDialog: null,
      warnDialog:null
    };
  },
  methods: {
    closeDialog() {
      this.errorDialog=null;
      this.successDialog=null;
      this.warnDialog=null;
    }
  },
  mounted() {

    // For jump to letters
    window.addEventListener('keydown', (e) => {
      try {
        var k=e.key.toUpperCase();
        this.$scrollTo("#"+k);
      }
      catch(q) {

      }

    });

    // Clear session data on unload
    window.addEventListener('unload', function() {
      localStorage.removeItem("sdata");
    })

    this.$bus.$on("CloseDialogEvent", () => {
      this.errorDialog=null;
      this.successDialog=null;
      this.warnDialog=null;
    });
    
    this.$bus.$on("ShowDialogEvent", (typ, txt) => {
      this.errorDialog=null;
      this.successDialog=null;
      this.warnDialog=null;
      if (typ===0) {
        this.successDialog=txt;
      }
      else if (typ===1) {
        this.errorDialog=txt;
      }
      else {
        this.warnDialog=txt;
      }
    });

    if (this.$hostname.indexOf("stage")>-1 || this.$hostname.indexOf("local")>-1) {
      this.isStaging=true;
    }
  },
}
</script>
